import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Button, Input } from 'hljd'
import { goToInsertCustomer } from '@util'
import Store from '../HomeInfo/CheckIn/store'
import { observer } from 'mobx-react'

const btnStyle = {
  width: 120,
  height: 48,
  fontSize: 16
}

/**
 * 这个组件不显示左侧菜单栏和右下角私信、通知
 */
@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store('route')
  }

  componentDidMount() {
    document.querySelector('#sideMenu').style.display = 'none'
    document.querySelector('#bottomFloat').style.display = 'none'
  }

  componentWillUnmount() {
    document.querySelector('#sideMenu').style.display = 'initial'
    document.querySelector('#bottomFloat').style.display = 'initial'
  }

  render() {
    const { searchCustomerByPhone, onChange, searchText } = this.store

    return (
      <HeaderView>
        <div className="center" style={{ textAlign: 'center', marginTop: -50 }}>
          <div
            style={{
              color: '#333',
              fontWeight: 'bold',
              fontSize: 24,
              marginBottom: 48
            }}
          >
            客户信息录入
          </div>

          <div>
            <Input
              placeholder="请输入手机号码"
              onChange={onChange}
              value={searchText}
              style={{
                width: 300,
                height: 48
              }}
            />
            <Button
              style={{ ...btnStyle, margin: '0 10px 0 20px' }}
              onClick={searchCustomerByPhone}
            >
              查询客户
            </Button>
            <Button
              style={btnStyle}
              type="primary"
              onClick={() => goToInsertCustomer(searchText)}
            >
              直接录入
            </Button>
          </div>
        </div>
      </HeaderView>
    )
  }
}
